import React from "react";
import { AxiosError, AxiosResponse } from "axios";
import { createApi } from "../../../utils/createApi";
import { markSiteUnsynced } from "../../../utils/syncStore";
import { IgnoreZonesBreadCrumbs } from "../../EditIgnoreZones/IgnoreZonesBreadCrumbs";
import { createIgnoreZonesLinksArray } from "../../EditIgnoreZones/EditIgnoreZonesUtils/createIgnoreZonesLinksArray";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";
import { USMonitoringAlertsTab } from "../USMonitoringAlertsTab";
import { getNumbersAfterEditCamera, getNumbersAfterSites } from "../EditCamera";

export const handleSubmitNewUSMonitoringAlert = async (
  cameraGeneralInfo: any,
  uSMonitoringAlerts: any,
  postObject: any,
  navigate: any,
  setBackdropLoadingScreenOn: any,
  setCameraGeneralInfo: any,
  setCameraGeneralInfoBackup: any,
  setGeneralInfoChangesMade: any,
  setPatchObject: any,
  setUSMonitoringAlerts: any,
  setActiveTab: any,
  setAddUSMonitoringAlertDialogOpen: any,
  cameraGeneralInfoBackup: any,
  setIgnoreZonesBreadCrumbs: any,
  handleSitesBreadcrumbClick: any,
  handleSingularSiteBreadcrumbClick: any
) => {
  const AxiosUI = createApi(``);
  const retryFunction = () => {
    handleSubmitNewUSMonitoringAlert(
      cameraGeneralInfo,
      uSMonitoringAlerts,
      postObject,
      navigate,
      setBackdropLoadingScreenOn,
      setCameraGeneralInfo,
      setCameraGeneralInfoBackup,
      setGeneralInfoChangesMade,
      setPatchObject,
      setUSMonitoringAlerts,
      setActiveTab,
      setAddUSMonitoringAlertDialogOpen,
      cameraGeneralInfoBackup,
      setIgnoreZonesBreadCrumbs,
      handleSitesBreadcrumbClick,
      handleSingularSiteBreadcrumbClick
    );
  };

  const createNewStreamsObject = (streams: any) => {
    const updatedStreams = streams;
    updatedStreams.forEach((object: any, index: any) => {
      const updatedUSMonitoringAlerts = object?.us_monitoring_alerts
        ? object.us_monitoring_alerts
        : [];
      updatedUSMonitoringAlerts.push(postObject);
      updatedStreams[index].us_monitoring_alerts = updatedUSMonitoringAlerts;
    });
    return updatedStreams;
  };

  let postPatchObjectFail = false;
  let getSiteCamerasFail = false;
  await AxiosUI.patch(
    `/camera/${getNumbersAfterEditCamera(location.href)}/general_info/`,
    {
      streams: createNewStreamsObject(cameraGeneralInfo.streams),
    }
  ).then(
    (response: AxiosResponse) => {
      postPatchObjectFail = false;
      markSiteUnsynced();
      setCameraGeneralInfo(response.data);
      setCameraGeneralInfoBackup(response.data);
      const pushedArray: any[] = [];
      response.data.streams[0].us_monitoring_alerts.forEach(
        (alertObject: any) => {
          pushedArray.push(alertObject);
        }
      );
      setUSMonitoringAlerts(pushedArray);
      setGeneralInfoChangesMade(false);
      setPatchObject({});
      setActiveTab(
        <USMonitoringAlertsTab
          uSMonitoringAlerts={pushedArray}
          setAddUSMonitoringAlertDialogOpen={setAddUSMonitoringAlertDialogOpen}
        />
      );
      setBackdropLoadingScreenOn(false);
    },
    (reason: AxiosError) => {
      postPatchObjectFail = true;
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        setCameraGeneralInfo(cameraGeneralInfoBackup);
        setPatchObject({
          camera_name: cameraGeneralInfoBackup.camera_name,
          streams: cameraGeneralInfoBackup.streams,
        });
        setBackdropLoadingScreenOn(false);
      });
    }
  );
  !postPatchObjectFail &&
    (await AxiosUI.get(
      `camera/site/?customer__id=${getNumbersAfterSites(location.href)}`
    ).then(
      (response: AxiosResponse) => {
        getSiteCamerasFail = false;
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
      },
      (reason: AxiosError) => {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {
          getSiteCamerasFail = true;
        });
      }
    ));
  !postPatchObjectFail &&
    !getSiteCamerasFail &&
    (await AxiosUI.get(
      `customer/${getNumbersAfterSites(location.href)}/about/`
    ).then(
      (response: AxiosResponse) => {
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
        localStorage.setItem("integrationType", response.data.integration_type);
        setIgnoreZonesBreadCrumbs(
          <IgnoreZonesBreadCrumbs
            linksArray={createIgnoreZonesLinksArray(response.data.breadcrumbs)}
            handleSitesBreadcrumbClick={handleSitesBreadcrumbClick}
            handleSingularSiteBreadcrumbClick={
              handleSingularSiteBreadcrumbClick
            }
            styling="absolute top-[10px] left-[30px]"
          />
        );
      },
      (reason: AxiosError) => {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {
          setBackdropLoadingScreenOn(false);
        });
      }
    ));
};
